import { createStyles, makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) =>
  createStyles({
    info: {
      listStyleType: 'none',
      padding: 0,
      margin: 0,
      '& li': {
        marginTop: 8,
        '&:first-child': {
          marginTop: 0,
        },
        '& img': {
          marginRight: 8,
        },
        '& button img': {
          marginRight: 0,
        },
      },
    },
    list: {
      display: 'flex',
      alignItems: 'center',
    },
    button: {
      backgroundColor: 'transparent',
      border: 'none',
      padding: 0,
      fontFamily: 'inherit',
      fontSize: 'inherit',
      color: '#0033B7',
      cursor: 'pointer',
    },
    rankingMobile: {
      display: 'flex',
      alignItems: 'center',
      marginTop: 8,
      [theme.breakpoints.up('sm')]: {
        display: 'none',
      },
    },
    rankingDesktop: {
      marginLeft: 16,
      lineHeight: '100%',
      [theme.breakpoints.down('xs')]: {
        display: 'none',
      },
    },
    registrationButton: {
      marginTop: 24,
    },
    rankingIcon: {
      opacity: 0.24,
    },
  }),
);

export default useStyles;
